import type { i18n } from 'i18next';

/**
 * Возвращает направление языка по указанному языку.
 */
export const getLanguageDirection = (i18n: i18n): 'ltr' | 'rtl' => {
  return i18n.dir(i18n.language);
};
